import type { ReactElement } from 'react'

import { BodyL, H1, H2 } from '@monthio/design-system'
import { ErrorCircle } from '@monthio/icons'
import { COLORS } from '@monthio/react-components'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import type { EskatError } from '../Eskat.types'

const ErrorIcon = styled(ErrorCircle)`
	width: 40px;
`

const EskatListCard = styled.div`
	text-align: left;
	padding: 16px;
	margin: 12px 0;
	background-color: ${COLORS.BACKGROUND_LIGHT};
`

const StyledH2Flow = styled(H2)`
	margin: 0 0 4px 0;

	${(props) => props.theme.breakpoints.up('sm')} {
		margin: 0 0 8px 0;
	}
`

interface EskatConsentErrorProps {
	error: EskatError
}

export const EskatConsentError = ({
	error,
}: EskatConsentErrorProps): ReactElement => {
	const { t } = useTranslation()

	return (
		<>
			<div>
				<ErrorIcon />
			</div>
			<H1>{t(error.titleKey)}</H1>
			<BodyL>{t(error.descriptionKey)}</BodyL>
			<EskatListCard>
				<StyledH2Flow>{t('eskat-consent-error-open-popup-text')}</StyledH2Flow>
				<BodyL>{t('eskat-consent-error-open-popup-solution')}</BodyL>
			</EskatListCard>
			<EskatListCard>
				<StyledH2Flow>
					{t('eskat-consent-error-technical-problem-text')}
				</StyledH2Flow>
				<BodyL>{t('eskat-consent-error-technical-problem-solution')}</BodyL>
			</EskatListCard>
			<EskatListCard>
				<StyledH2Flow>
					{t('eskat-consent-error-wrong-redirection-text')}
				</StyledH2Flow>
				<BodyL>
					{t('eskat-consent-error-wrong-redirection-text-solution')}
				</BodyL>
			</EskatListCard>
		</>
	)
}
